/* unplugin-vue-components disabled */import { render } from "./3d.vue?vue&type=template&id=2551a663&scoped=true"
import script from "./3d.vue?vue&type=script&lang=js"
export * from "./3d.vue?vue&type=script&lang=js"

import "./3d.vue?vue&type=style&index=0&id=2551a663&lang=css"
import "./3d.vue?vue&type=style&index=1&id=2551a663&scoped=true&lang=css"
import "./3d.vue?vue&type=style&index=2&id=2551a663&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2551a663"]])

export default __exports__